import $ from 'jquery';
import PopinView from "./Popin.view";

// constants
var POPIN_LIGHT_CMS = {
    SELECTOR_POPIN_MODAL_OVERLAY : 'dcw_popin',
    SELECTOR_POPIN_MODAL_TITLE : 'dcw_popin-title',
    SELECTOR_POPIN_MODAL_TEXT : 'dcw_popin-desc',
    SELECTOR_BTN_POPIN_MODAL : '.js-openPopinModal',
    SELECTOR_TEXT_TO_DISPLAY : '.js-popinText'
};

/*
    Work with global Popinview.js

    Params :
    - Id of container
    - Id of title container
    - Id of description container
    - Infos with title & description

    Usefull to use it with others contexts
 */

function PopinLightCMS(popId, popTitleId, popDescrId, infos) {

    // get Element and return if doesn't exist
    this.root = document.getElementById(popId);
    if(!this.root){
        return;
    }

    // get container Title & Text
    this.titleCont = document.getElementById(popTitleId);
    this.descrCont = document.getElementById(popDescrId);

    // get Data
    this.infos = infos;

    this.render();
}

PopinLightCMS.prototype.render = function () {

    this.popinInfoView = new PopinView(
        this.root,
        this.titleCont ,
        this.descrCont
    );

    this.popinInfoView.render(this.infos);
};

PopinLightCMS.prototype.show = function () {
    this.popinInfoView.show();
}

/*
    When a btn with the class js-popinText is clicked,
    we initialize modal popin light
 */
var initPopinModal = function initPopinModal() {
    var $btnPopin = $(POPIN_LIGHT_CMS.SELECTOR_BTN_POPIN_MODAL);

    if (!$btnPopin.length === 0) {
        return;
    }

    $btnPopin.click(function(e) {
        e.preventDefault();

        var $currenBtn = $(this);
        var infos = {
            keyword : $currenBtn.text(),
            definition: $currenBtn.next(POPIN_LIGHT_CMS.SELECTOR_TEXT_TO_DISPLAY).html()
        }

        // Init each time because we could have several btns
        var popinLight = new PopinLightCMS(
            POPIN_LIGHT_CMS.SELECTOR_POPIN_MODAL_OVERLAY,
            POPIN_LIGHT_CMS.SELECTOR_POPIN_MODAL_TITLE,
            POPIN_LIGHT_CMS.SELECTOR_POPIN_MODAL_TEXT,
            infos
        );

        if (popinLight) {
            popinLight.show();
        }
    });
};

export {initPopinModal};


// WEBPACK FOOTER //
// ./src/js/cms/commons/Popin/init-popin-modal.js